var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderActivityPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.64997L8.41 9.38997C8.58545 9.46884 8.73443 9.59664 8.83908 9.75804C8.94372 9.91945 8.9996 10.1076 9 10.3V19.66L0.67 15.91C0.474715 15.8244 0.307928 15.6848 0.189242 15.5076C0.0705555 15.3305 0.00490265 15.1231 0 14.91V5.64997ZM11 10.3V19.66L19.33 15.91C19.5253 15.8244 19.6921 15.6848 19.8108 15.5076C19.9294 15.3305 19.9951 15.1231 20 14.91V5.64997L11.59 9.38997C11.4145 9.46884 11.2656 9.59664 11.1609 9.75804C11.0563 9.91945 11.0004 10.1076 11 10.3ZM10.45 0.0999725C10.3086 0.0358944 10.1552 0.00274658 10 0.00274658C9.84479 0.00274658 9.69137 0.0358944 9.55 0.0999725L1 3.91997L9.55 7.71997C9.67892 7.77792 9.81866 7.80789 9.96 7.80789C10.1013 7.80789 10.2411 7.77792 10.37 7.71997L19 3.91997L10.45 0.0999725Z",
    fill: "#22CDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderActivityPickup);
export default __webpack_public_path__ + "static/media/order-activity-pickup.d820e1f65345258725e1a0393688ae1e.svg";
export { ForwardRef as ReactComponent };